(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$filter', 'Principal', 'LoginService', '$state', 'TechnicienHomeStat', 'ExportPraxedo', 'DateUtils'];

    function HomeController ($scope, $filter, Principal, LoginService, $state, TechnicienHomeStat, ExportPraxedo, DateUtils) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.isAdmin = false;
        vm.login = LoginService.open;
        vm.progressBarMax = 200;
        vm.register = register;
        vm.getBackgroundColor = getBackgroundColor;
        vm.findCalendarDayInfo = findCalendarDayInfo;
        vm.viewCalendar = viewCalendar;
        vm.formatDayFr = formatDayFr;
        vm.formatMonthFr = formatMonthFr;
        vm.formatDate = formatDate;
        vm.theoricalPercentageDay = new Date().setDate(new Date().getDate() - 1);
        vm.dateStart = null;
        vm.dateEnd = null;
        vm.previousMonth = previousMonth;
        vm.actualMonth = actualMonth;
        vm.nextMonth = nextMonth;
        vm.isEquipeInWeekRange = isEquipeInWeekRange;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        function getBackgroundColor(day, calendarInfos) {
            var dayInfo = vm.findCalendarDayInfo(day, calendarInfos);
            if(moment(day).isFerie()){
                return " tdGreySunday";
            }
            if (dayInfo) {
                if (dayInfo.astreinteId) {
                    return 'tdYellow';
                }
                if (dayInfo.conges && dayInfo.conges.length > 0) {
                    if (!dayInfo.conges[0].validate) {
                        return 'tdRed';
                    } else {
                        switch (dayInfo.conges[0].status) {
                            case "AT":
                                return "tdPink";
                            case "CHP":
                                return "tdGrey";
                            case "CP":
                                return "tdBlue";
                            case "JR":
                                return "tdGreen";
                            case "JD":
                                return "tdOrange";
                            case "GD":
                                return "tdPurple";
                            default:
                                return 'none';
                        }
                    }
                }
                if (dayInfo.astreintePlanifie && dayInfo.astreintePlanifie.length > 0) {
                    switch (dayInfo.astreintePlanifie[0].type) {
                        case "CUIVRE":
                            return "tdGreen";
                        case "FIBRE_CHEF_EQUIPE_BINOME":
                            return "tdYellowChef";
                        case "FIBRE_BINOME":
                            return "tdBeigeBinome";
                        case "FIBRE_CHEF_MONOME":
                            return "tdLightBrown";
                        default:
                            return 'none';
                    }
                }
            }
            return 'none';
        }

        function findCalendarDayInfo(day, calendarInfos) {
            var formattedDay = $filter('date')(day, 'yyyy-MM-dd');
            for (var i = 0; i < calendarInfos.length; i++) {
                if (calendarInfos[i].date === formattedDay) {
                    return calendarInfos[i];
                }
            }
            return undefined;
        }

        function viewCalendar(stat){
            if (stat.display == undefined || stat.display == null){
                stat.display = true;
            }else {
                stat.display = !stat.display;
            }
        }

        DateUtils.loadCutoffDay().then(function () {
            getAccount().then(function() {
                if(vm.isAuthenticated){
                    getAllDates();
                    loadStats();
                    loadLastImportsDates();
                }
            });
        });

        function loadStats() {
            // Format local (pas toISOString/UTC) : un Date à minuit local serait
            // converti a la veille en UTC+2 et la plage chevaucherait 2 periodes de paie.
            var filter = {
                dateFrom: $filter('date')(vm.dateStart, 'yyyy-MM-dd'),
                dateTo: $filter('date')(vm.dateEnd, 'yyyy-MM-dd'),
                civilMonth: true
            }

            TechnicienHomeStat.query(filter,onSuccess, onError);
        }

        function loadLastImportsDates() {
            ExportPraxedo.getLastImports({},
                function onSuccess(data){
                    vm.lastImportFiles = data;
                },
                onError)
        }

        function onSuccess(data, headers) {
            vm.technicienHomeStats = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function previousMonth() {
            var prev = new Date(vm.dateStart.getFullYear(), vm.dateStart.getMonth() - 1, vm.dateStart.getDate());
            vm.dateStart = DateUtils.getFirstDayOfPayrollPeriod(prev);
            vm.dateEnd = DateUtils.getLastDayOfPayrollPeriod(prev);
            vm.month = vm.dateStart;
            getWeeks();
            loadStats();
        }

        function actualMonth() {
            getAllDates();
            loadStats();
        }

        function nextMonth() {
            var next = new Date(vm.dateStart.getFullYear(), vm.dateStart.getMonth() + 1, vm.dateStart.getDate());
            vm.dateStart = DateUtils.getFirstDayOfPayrollPeriod(next);
            vm.dateEnd = DateUtils.getLastDayOfPayrollPeriod(next);
            vm.month = vm.dateStart;
            getWeeks();
            loadStats();
        }

        function getAllDates() {
            var now = new Date();

            vm.dateStart = DateUtils.getFirstDayOfPayrollPeriod(now);
            vm.dateEnd = DateUtils.getLastDayOfPayrollPeriod(now);
            vm.month = vm.dateStart;
            getWeeks();
        }

        function getWeeks() {
            var startDate = new Date(vm.dateStart);
            var endDate = new Date(vm.dateEnd);

            startDate.setHours(0,0,0,0);
            endDate.setHours(0,0,0,0);

            var weeks = {};
            var currentWeek = [];
            var weekCounter = 1;
            var d = new Date(startDate);

            while (d <= endDate) {
                if (d.getDay() !== 0) {
                    currentWeek.push(new Date(d));
                }
                if (d.getDay() === 6 || d.getTime() === endDate.getTime()) {
                    weeks['Semaine ' + weekCounter] = currentWeek;
                    currentWeek = [];
                    weekCounter++;
                }
                d.setDate(d.getDate() + 1);
            }
            vm.weeks = weeks;
        }

        function isEquipeInWeekRange(equipe, week) {
            var equipeStart = new Date(equipe.dateStart);

            for (var i = 0; i < week.length; i++) {
                var weekDate = new Date(week[i]);
                if (weekDate.toDateString() === equipeStart.toDateString()) {
                    return true;
                }
            }

            return false;
        }

        function formatDayFr(day) {
            var days = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];
            return days[day.getDay()];
        }

        function formatMonthFr(isoDateString) {
            var date = new Date(isoDateString);
            var options = { month: 'long' };
            return date.toLocaleString('fr-FR', options);
        }

        function formatDate(timestamp) {
            return $filter('date')(timestamp, 'yyyy-MM-dd');
        }

        function getAccount() {
            return Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated();
                Principal.hasAuthority('ROLE_ADMIN').then(function (isAdmin) {
                    vm.isAdmin = isAdmin;
                });
                return account;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
